// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/VideoUploader.css */
.video-uploader {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.source-buttons {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.source-button {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.source-button:hover {
  background-color: #f7f7f7;
  border-color: #7209b7;
}

.source-button.selected {
  background-color: rgba(114, 9, 183, 0.1);
  border-color: #7209b7;
}

.source-icon {
  font-size: 28px;
  margin-bottom: 12px;
}

.source-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

/* New dropzone styles */
.dropzone {
  margin-bottom: 24px;
  padding: 24px;
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
  cursor: pointer;
}

.dropzone.active {
  border-color: #7209b7;
  background-color: rgba(114, 9, 183, 0.05);
}

.dropzone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dropzone-icon {
  font-size: 40px;
  margin-bottom: 16px;
  color: #7209b7;
}

.dropzone-text {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.dropzone-subtext {
  font-size: 14px;
  color: #666;
}

.file-display {
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.file-info-container {
  display: flex;
  align-items: center;
}

.file-icon {
  font-size: 24px;
  margin-right: 12px;
}

.file-name {
  font-size: 16px;
  color: #333;
  word-break: break-all;
  flex-grow: 1;
}

.clear-file-button {
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.clear-file-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
  color: #7209b7;
}

.video-preview {
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.video-preview video {
  display: block;
  max-width: 100%;
}

.upload-progress {
  margin-bottom: 24px;
}

.progress-bar {
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background-color: #7209b7;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.generate-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px;
  background-color: #7209b7;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 24px;
}

.generate-button:hover {
  background-color: #5c0996;
}

.generate-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.button-text {
  margin-right: 8px;
}

.button-icon {
  font-size: 20px;
}

.ai-features {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 16px;
}

.feature-item {
  flex: 1 1;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background-color: #f7f7f7;
  border-radius: 8px;
  text-align: center;
}

.feature-icon {
  font-size: 24px;
  margin-bottom: 12px;
}

.feature-text {
  font-size: 14px;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/css/VideoUploader.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["/* src/VideoUploader.css */\n.video-uploader {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.source-buttons {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.source-button {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.source-button:hover {\n  background-color: #f7f7f7;\n  border-color: #7209b7;\n}\n\n.source-button.selected {\n  background-color: rgba(114, 9, 183, 0.1);\n  border-color: #7209b7;\n}\n\n.source-icon {\n  font-size: 28px;\n  margin-bottom: 12px;\n}\n\n.source-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n/* New dropzone styles */\n.dropzone {\n  margin-bottom: 24px;\n  padding: 24px;\n  border: 2px dashed #e0e0e0;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.dropzone.active {\n  border-color: #7209b7;\n  background-color: rgba(114, 9, 183, 0.05);\n}\n\n.dropzone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.dropzone-icon {\n  font-size: 40px;\n  margin-bottom: 16px;\n  color: #7209b7;\n}\n\n.dropzone-text {\n  font-size: 18px;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.dropzone-subtext {\n  font-size: 14px;\n  color: #666;\n}\n\n.file-display {\n  margin-bottom: 24px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.file-info-container {\n  display: flex;\n  align-items: center;\n}\n\n.file-icon {\n  font-size: 24px;\n  margin-right: 12px;\n}\n\n.file-name {\n  font-size: 16px;\n  color: #333;\n  word-break: break-all;\n  flex-grow: 1;\n}\n\n.clear-file-button {\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.clear-file-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n  color: #7209b7;\n}\n\n.video-preview {\n  margin-bottom: 24px;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.video-preview video {\n  display: block;\n  max-width: 100%;\n}\n\n.upload-progress {\n  margin-bottom: 24px;\n}\n\n.progress-bar {\n  height: 10px;\n  background-color: #e0e0e0;\n  border-radius: 5px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background-color: #7209b7;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n}\n\n.generate-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 16px;\n  background-color: #7209b7;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-bottom: 24px;\n}\n\n.generate-button:hover {\n  background-color: #5c0996;\n}\n\n.generate-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.button-text {\n  margin-right: 8px;\n}\n\n.button-icon {\n  font-size: 20px;\n}\n\n.ai-features {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.feature-item {\n  flex: 1;\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  background-color: #f7f7f7;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.feature-icon {\n  font-size: 24px;\n  margin-bottom: 12px;\n}\n\n.feature-text {\n  font-size: 14px;\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
